import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useSite } from "@/context/SiteContext";
import { SocialButtons } from "@/components/Socials";

export const Footer = () => {
  const { site } = useSite();
  const c = site.content;

  return (
    <footer className="bg-[#0A3823] text-white diagonal-stripes" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={c.logo_url} alt="Team logo" className="h-12 w-12 rounded-full object-cover ring-2 ring-white/20" />
              <div className="leading-tight">
                <span className="font-condensed block text-xl font-extrabold uppercase">{c.team_name}</span>
                <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#F59E0B]">{c.contact_school}</span>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">{c.footer_text}</p>
            <SocialButtons className="mt-5" />
          </div>

          <div>
            <h4 className="font-condensed text-lg font-bold uppercase tracking-wide mb-4 text-[#F59E0B]">Site Menu</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-white/75 hover:text-white transition-colors" data-testid={`footer-${l.testid}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-condensed text-lg font-bold uppercase tracking-wide mb-4 text-[#F59E0B]">Contact</h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex items-start gap-2.5"><Mail size={16} className="mt-0.5 shrink-0 text-[#F59E0B]" /><a href={`mailto:${c.contact_email}`} className="hover:text-white" data-testid="footer-email">{c.contact_email}</a></li>
              <li className="flex items-start gap-2.5"><Phone size={16} className="mt-0.5 shrink-0 text-[#F59E0B]" /><a href={`tel:${c.contact_phone}`} className="hover:text-white" data-testid="footer-phone">{c.contact_phone}</a></li>
              <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-[#F59E0B]" /><span>{c.contact_address}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-condensed text-lg font-bold uppercase tracking-wide mb-4 text-[#F59E0B]">Home Field</h4>
            <p className="text-sm text-white/75 leading-relaxed">{c.field_name}<br />{c.contact_school}<br />Norwalk, Connecticut</p>
            <p className="text-sm text-white/75 mt-4">Head Coach: <span className="text-white font-semibold">{c.contact_coach}</span></p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/60">© 2026 {c.team_name}. All rights reserved.</p>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F59E0B]">Go Bears</p>
        </div>

        <div className="mt-6 text-center" data-testid="footer-credit">
          <p className="text-xs text-white/50">
            Created by{" "}
            <a
              href="https://omraowebstudio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-[#F59E0B] transition-colors font-medium"
              data-testid="footer-credit-link"
            >
              OMRAO Web Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
